import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Users, Plus, Edit, Trash2, RotateCcw } from "lucide-react";

export const EmployeeListTab = ({ 
  employees, 
  loading, 
  onAddEmployee, 
  onEditEmployee, 
  onDeleteEmployee,
  onReactivateEmployee,
}) => {
  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <Button onClick={onAddEmployee} className="bg-green-600 hover:bg-green-700" data-testid="add-employee-btn">
          <Plus className="h-4 w-4 mr-2" />
          Add Employee
        </Button>
      </div>

      <div className="grid gap-4">
        {employees.map((employee) => (
          <Card key={employee.id} className={`${!employee.is_active ? 'opacity-60 bg-gray-50' : ''}`} data-testid={`employee-card-${employee.id}`}>
            <CardContent className="p-4">
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <div className="flex items-center gap-3">
                    <h3 className="font-semibold text-lg">
                      {employee.first_name} {employee.last_name}
                    </h3>
                    <span className="text-sm text-gray-500">#{employee.employee_number}</span>
                    <span className={`px-2 py-0.5 text-xs rounded ${
                      employee.employment_type === 'permanent' ? 'bg-green-100 text-green-700' :
                      employee.employment_type === 'casual' ? 'bg-yellow-100 text-yellow-700' :
                      'bg-blue-100 text-blue-700'
                    }`}>
                      {employee.employment_type.toUpperCase()}
                    </span>
                    {!employee.is_active && (
                      <span className="px-2 py-0.5 text-xs rounded bg-red-100 text-red-700">
                        INACTIVE
                      </span>
                    )}
                  </div>
                  <div className="grid grid-cols-4 gap-4 mt-2 text-sm">
                    <div><span className="text-gray-500">Position:</span> {employee.position}</div>
                    <div><span className="text-gray-500">Contact:</span> {employee.contact_number || "-"}</div>
                    <div>
                      <span className="text-gray-500">Salary:</span>{" "}
                      R {employee.basic_salary?.toFixed(2)} / {employee.salary_type === 'monthly' ? 'month' : 'hour'}
                    </div>
                    <div><span className="text-gray-500">Started:</span> {employee.start_date}</div>
                  </div>
                  {employee.leave_balance && (
                    <div className="flex gap-4 mt-2 text-xs">
                      <span className="text-green-600">Annual: {employee.leave_balance.annual} days</span>
                      <span className="text-blue-600">Sick: {employee.leave_balance.sick} days</span>
                      <span className="text-purple-600">Family: {employee.leave_balance.family} days</span>
                    </div>
                  )}
                </div>
                <div className="flex gap-2">
                  <Button variant="outline" size="sm" onClick={() => onEditEmployee(employee)} data-testid={`edit-employee-${employee.id}`}>
                    <Edit className="h-4 w-4" />
                  </Button>
                  {employee.is_active ? (
                    <Button variant="outline" size="sm" className="text-red-600" onClick={() => onDeleteEmployee(employee.id)} data-testid={`delete-employee-${employee.id}`}>
                      <Trash2 className="h-4 w-4" />
                    </Button>
                  ) : (
                    onReactivateEmployee && (
                      <Button
                        variant="outline"
                        size="sm"
                        className="text-green-700 border-green-500 hover:bg-green-50"
                        onClick={() => onReactivateEmployee(employee.id)}
                        data-testid={`reactivate-employee-${employee.id}`}
                      >
                        <RotateCcw className="h-4 w-4 mr-1" />
                        Reactivate
                      </Button>
                    )
                  )}
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
        {employees.length === 0 && !loading && (
          <Card>
            <CardContent className="text-center py-12">
              <Users className="h-12 w-12 mx-auto text-gray-400 mb-4" />
              <p className="text-gray-500">No employees yet. Add your first employee to get started.</p>
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
};
